import { render, staticRenderFns } from "./PastTimeBackdrop.vue?vue&type=template&id=31a8e033&scoped=true&"
import script from "./PastTimeBackdrop.vue?vue&type=script&lang=js&"
export * from "./PastTimeBackdrop.vue?vue&type=script&lang=js&"
import style0 from "./PastTimeBackdrop.vue?vue&type=style&index=0&id=31a8e033&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8e033",
  null
  
)

export default component.exports